
import "./Service_pages.scss";
import img from "./services/Aligners.png"; // Replace with your actual image path
import img2 from "./services/dental.png";
import { FaCheckCircle, FaTooth, FaSmile, FaStar, FaUserMd, FaHeart, FaShieldAlt, FaClinicMedical, FaLaptopMedical, FaUtensils, } from 'react-icons/fa';
import { MdOutlineStarPurple500, MdOutlineHealthAndSafety, MdOutlineVisibility, MdScanner,  } from "react-icons/md";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const TeethAligners = () => {

    const types = [
        {
            title: "Digital Aligner Trays",
            icon: <MdScanner />,
            desc: "Custom-fabricated trays created using medical-grade transparent plastic. These are designed to be virtually invisible while applying the precise pressure needed for tooth movement.",
        },
        {
            title: "Customized Sequential Series",
            icon: <MdOutlineStarPurple500 />,
            desc: "A series of unique aligners where each tray is slightly different, moving your teeth step-by-step from their current position to the final ideal alignment.",
        },
        {
            title: "Removable Orthodontics",
            icon: <FaShieldAlt />,
            desc: "Unlike fixed braces, these aligners can be removed for eating and cleaning, offering unparalleled convenience and maintaining superior oral hygiene throughout the journey.",
        },
        {
            title: "Precision Bite Correction",
            icon: <MdOutlineHealthAndSafety />,
            desc: "Advanced clear systems designed to treat mild bite problems, crowding, and spacing issues without the aesthetic drawbacks of traditional metal wires.",
        },
    ];

    const benefitsTable = [
        {
            category: "Comfort",
            benefit: "Smooth Fit",
            description: "Designed to fit smoothly over teeth, significantly reducing irritation to the gums and cheeks compared to braces.",
        },
        {
            category: "Aesthetics",
            benefit: "Nearly Invisible",
            description: "Transparent medical-grade plastic ensures that your orthodontic treatment remains discreet and professional.",
        },
        {
            category: "Hygiene",
            benefit: "Better Oral Care",
            description: "Because aligners are removable, patients can brush and floss normally, preventing plaque buildup and decay.",
        },
        {
            category: "Lifestyle",
            benefit: "Daily Convenience",
            description: "Allows patients to continue their daily routines, social interactions, and sports without restrictions.",
        },
        {
            category: "Results",
            benefit: "Enhanced Smile",
            description: "Gradually creates a balanced, attractive, and properly aligned smile through controlled dental movements.",
        },
    ];

    const reasons = [
        {
            icon: <FaUserMd />,
            title: 'Experienced Ortho Specialists',
            description: 'Our team specializes in modern aligner therapy, ensuring safe and effective tooth movement for all ages.'
        },
        {
            icon: <FaLaptopMedical />,
            title: 'Advanced Digital Scanners',
            description: 'We use high-precision intraoral scanners and CBCT imaging for detailed analysis and perfect tray fitting.'
        },
        {
            icon: <FaHeart />,
            title: 'Patient-Friendly Approach',
            description: 'We prioritize your comfort and aesthetics, providing a stress-free alternative to traditional orthodontic procedures.'
        },
        {
            icon: <MdOutlineVisibility />,
            title: 'Personalized Planning',
            description: 'Using advanced software, we create a customized roadmap for your teeth, allowing you to see progress at every stage.'
        },
        {
            icon: <FaShieldAlt />,
            title: 'High-Quality Materials',
            description: 'Our aligners are made from durable, safe, and biocompatible materials for optimal clinical outcomes.'
        },
        {
            icon: <FaClinicMedical />,
            title: 'Comprehensive Local Care',
            description: 'Conveniently located in HSR Layout, we provide full-service aligner monitoring and maintenance in one place.'
        }
    ];

    return (
        <>
            <div className="service1-section">
                <Helmet>
                    <title>Teeth Aligners in HSR Layout | Clear Aligner Treatment Bengaluru</title>
                    <meta
                        name="description"
                        content="Straighten your teeth discreetly with advanced Aligners in HSR Layout at Kosmix Dental Clinic. Nearly invisible, comfortable, and customized clear trays."
                    />
                    <link
                        rel="canonical"
                        href="https://www.kosmixdentalclinic.com/services/teeth-aligners-in-hsr-layout"
                    />
                </Helmet>

                {/* HERO SECTION */}
                <div className="hero">
                    <h1 className="service1-title-text" data-aos="fade-down" data-aos-delay="200" style={{ fontFamily: 'initial' }}>
                        Teeth Aligners Treatment in HSR Layout, Bengaluru
                    </h1>

                    <div className="hero-content">
                        <div className="hero-image" data-aos="zoom-in-right" data-aos-delay="200" data-aos-duration="800">
                            <img src={img} alt="Teeth Aligner Treatment" />
                        </div>

                        <div className="hero-text" data-aos="zoom-in-left" data-aos-delay="200" data-aos-duration="800">
                            <p>
                                Straight and properly aligned teeth play an important role in maintaining good oral health and an attractive smile. <strong>Teeth aligners</strong> are a modern orthodontic solution designed to gradually correct misaligned teeth and improve overall dental alignment.
                            </p>
                            <p>
                                At Kosmix Dental Clinic in HSR Layout, Bengaluru, we provide advanced aligner treatments that help patients achieve straighter teeth comfortably and effectively. Using modern digital technology, our dental specialists create personalized aligner solutions that gently move teeth into their correct position.
                            </p>
                            <p>
                                Aligners are designed to fit comfortably over the teeth, making them a perfect option for patients who want to improve their smile and dental function without undergoing traditional orthodontic procedures.
                            </p>
                        </div>
                    </div>
                </div>

                {/* DEFINITION SECTION */}
                <div className="content" data-aos="fade-up" data-aos-delay="300" >
                    <SectionTitle title="What Are Teeth Aligners?" />
                    <div className="text_first" >
                        <p1>
                            Teeth aligners are custom-made orthodontic appliances used to straighten teeth and correct bite problems. Unlike traditional braces, they apply gentle pressure via transparent medical-grade plastic trays. They are ideal for treating crooked teeth, crowded teeth, gaps, mild bite problems, and uneven alignment while maintaining a natural appearance.
                        </p1>
                    </div>
                </div>

                {/* WHO CAN BENEFIT COMPARISON - REDESIGNED */}
                <div className="elegant-split-section" data-aos="fade-up" data-aos-delay="300">
                    <div className="elegant-split-col">
                        <h3>Who Can Benefit?</h3>
                        <h6>
                            Aligners are suitable for many patients seeking a modern way to enhance their smile:
                        </h6>

                        <ul className="elegant-list">
                            <li><FaCheckCircle className="list-icon" /> <span>Adults seeking a discreet and professional orthodontic solution.</span></li>
                            <li><FaCheckCircle className="list-icon" /> <span>Teenagers with developing dental alignment issues.</span></li>
                            <li><FaCheckCircle className="list-icon" /> <span>Individuals with crooked or overlapping teeth.</span></li>
                            <li><FaCheckCircle className="list-icon" /> <span>Patients with mild spacing issues or gaps between teeth.</span></li>
                            <li><FaCheckCircle className="list-icon" /> <span>Anyone wanting a more comfortable alternative to braces.</span></li>
                            <li><FaCheckCircle className="list-icon" /> <span>Individuals with minor bite issues looking for correction.</span></li>
                        </ul>
                    </div>

                    <div className="elegant-split-col">
                        <h3>Eating & Drinking Guidelines</h3>
                        <h6>
                            To maintain hygiene and protect your aligner trays, follow these recommendations:
                        </h6>

                        <ul className="elegant-list">
                            <li><FaUtensils className="list-icon" /> <span><strong>Remove Before Meals:</strong> Always take out aligners before eating anything.</span></li>
                            <li><FaUtensils className="list-icon" /> <span><strong>Avoid Sugary Drinks:</strong> Do not drink soda or juice while wearing aligners.</span></li>
                            <li><FaUtensils className="list-icon" /> <span><strong>Rinse Trays:</strong> Rinse your aligners before placing them back in your mouth.</span></li>
                            <li><FaUtensils className="list-icon" /> <span><strong>Clean Teeth First:</strong> Brush or clean your teeth before re-inserting trays.</span></li>
                            <li><FaUtensils className="list-icon" /> <span><strong>Lukewarm Water:</strong> Only drink water while the aligners are in place.</span></li>
                        </ul>
                    </div>
                </div>

                {/* ALIGNER CARE SECTION - REDESIGNED WITHOUT BOXES */}
                <section className="elegant-care-section">
                    <div className="content">
                        <h2 className="section-title" data-aos="fade-up">Caring for Your Aligners</h2>
                        <p1 className="text_first" data-aos="fade-up" data-aos-delay="100">
                            Proper maintenance ensures your treatment stays on track and your mouth remains healthy:
                        </p1>
                    </div>

                    <div className="elegant-care-grid">
                        {[
                            { title: "Regular Cleaning", desc: "Clean your aligners daily with lukewarm water. Never use hot water as it can deform the plastic.", icon: <FaStar /> },
                            { title: "Oral Hygiene", desc: "Always brush and floss your teeth before wearing aligners to prevent plaque buildup.", icon: <FaTooth /> },
                            { title: "Safe Storage", desc: "Store aligners in their protective case whenever they are not in use to avoid damage or loss.", icon: <FaShieldAlt /> },
                            { title: "Wear Time", desc: "Ensure you wear the aligners for the duration recommended by the dentist (typically 20-22 hours/day).", icon: <FaSmile /> },
                            { title: "Clinical Advice", desc: "Strictly follow the specific instructions provided by your dental specialist for optimal results.", icon: <FaUserMd /> },
                        ].map((item, index) => (
                            <div className="elegant-care-item" data-aos="fade-up" data-aos-delay={150 + index * 100} key={index}>
                                <div className="care-icon">{item.icon}</div>
                                <div className="care-text">
                                    <h4>{item.title}</h4>
                                    <p>{item.desc}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

                {/* ALIGNER TREATMENT TIMELINE - REDESIGNED */}
                <section className="elegant-process-section">
                    <div className="content" data-aos="fade-up">
                        <SectionTitle title="The Aligner Treatment Process" />
                        <p className="text_first">
                            Our step-by-step approach ensures safe, effective, and predictable tooth movement:
                        </p>
                    </div>

                    <div className="process-wrapper">
                        <div className="process-line"></div>

                        <div className="process-step" data-aos="fade-up">
                            <div className="step-number"><span>1</span></div>
                            <div className="step-content">
                                <span className="step-emoji">🩺</span>
                                <div>
                                    <h3>Dental Assessment</h3>
                                    <p>Evaluation of teeth, gums, and jaw alignment to determine the most appropriate treatment plan for your bite.</p>
                                </div>
                            </div>
                        </div>

                        <div className="process-step" data-aos="fade-up" data-aos-delay="50">
                            <div className="step-number"><span>2</span></div>
                            <div className="step-content">
                                <span className="step-emoji">📊</span>
                                <div>
                                    <h3>Digital Scanning & Planning</h3>
                                    <p>Advanced digital scanners capture precise images. We then use software to outline how your teeth will move over time.</p>
                                </div>
                            </div>
                        </div>

                        <div className="process-step" data-aos="fade-up" data-aos-delay="100">
                            <div className="step-number"><span>3</span></div>
                            <div className="step-content">
                                <span className="step-emoji">🛠️</span>
                                <div>
                                    <h3>Aligner Placement</h3>
                                    <p>You receive your first set of sequential trays along with detailed instructions on daily wear and care protocols.</p>
                                </div>
                            </div>
                        </div>

                        <div className="process-step" data-aos="fade-up" data-aos-delay="150">
                            <div className="step-number"><span>4</span></div>
                            <div className="step-content">
                                <span className="step-emoji">📈</span>
                                <div>
                                    <h3>Progress Evaluation</h3>
                                    <p>Periodic visits allow the dentist to monitor progress, provide the next set of trays, and make necessary adjustments.</p>
                                </div>
                            </div>
                        </div>

                        <div className="process-step" data-aos="fade-up" data-aos-delay="200">
                            <div className="step-number"><span>5</span></div>
                            <div className="step-content">
                                <span className="step-emoji">✨</span>
                                <div>
                                    <h3>Treatment Completion</h3>
                                    <p>Once ideal alignment is reached, the treatment ends. Retainers are typically recommended to maintain your new smile.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* ADVANCED SOLUTIONS GRID */}
                <section className="crown-types-section">
                    <div className="content" data-aos="fade-up">
                        <SectionTitle title="Aligner Technology at Kosmix" />
                        <p1 className="text_first">
                            We leverage cutting-edge tools to deliver precision diagnostics and highly personalized orthodontic correction.
                        </p1>
                    </div>

                    <div className="crown-grid">
                        {types.map((item, idx) => (
                            <div className="crown-card" key={idx} data-aos="zoom-in" data-aos-delay={idx * 200}>
                                <div className="icon">{item.icon}</div>
                                <h3>{item.title}</h3>
                                <p>{item.desc}</p>
                            </div>
                        ))}
                    </div>
                </section>

                {/* BENEFITS TABLE */}
                {/* BENEFITS TABLE - MINIMAL MODERN FORMAT */}
                <section className="minimal-table-section" data-aos="fade-up">
                    <div className="content">
                        <h2 className="section-title">Comprehensive Analysis of Aligner Benefits</h2>
                    </div>
                    <div className="minimal-table-wrapper">
                        <table className="minimal-benefits-table">
                            <thead>
                                <tr>
                                    <th>Benefit Category</th>
                                    <th>Specific Advantage</th>
                                    <th>Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                {benefitsTable.map((item, index) => (
                                    <tr key={index}>
                                        <td className="category-cell">
                                            {index === 0 || item.category !== benefitsTable[index - 1].category ? item.category : ""}
                                        </td>
                                        <td className="advantage-cell">{item.benefit}</td>
                                        <td className="desc-cell">{item.description}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </section>

                {/* TECHNOLOGY SECTION */}
                <section className="why-choose-us">
                    <div className="wrapper">
                        <div className="image-side" data-aos="zoom-in" data-aos-delay="100">
                            <img src={img2} alt="Modern Aligner Technology" />
                        </div>

                        <div className="text-side" data-aos="fade-up" data-aos-delay="300">
                            <h2>Modern Aligner Technology in Bengaluru</h2>
                            <p style={{ color: 'black' }}>
                                At <strong>Kosmix Dental Clinic</strong>, we utilize the most advanced diagnostic tools available to ensure effective results and patient comfort.
                            </p>

                            <div className="doctor-info" data-aos="fade-up" data-aos-delay="400">
                                <h3>Our Tech Stack</h3>
                                <div className="doctor">
                                    <span className="emoji">📸</span>
                                    <div>
                                        <h4>Digital Scanners & CBCT</h4>
                                        <p>For high-resolution dental analysis and precision 3D mapping of the jaw.</p>
                                    </div>
                                </div>
                                <div className="doctor">
                                    <span className="emoji">💻</span>
                                    <div>
                                        <h4>AI Treatment Planning</h4>
                                        <p>Advanced orthodontic software that simulates sequential tooth movements with 100% accuracy.</p>
                                    </div>
                                </div>
                            </div>

                            <p style={{ color: 'black' }}>
                                Our goal is to help you achieve a healthier, straighter smile through modern orthodontic solutions that prioritize both function and aesthetics.
                            </p>
                        </div>
                    </div>
                </section>

                {/* FAQ SECTION */}
                <section className="pricing-section" data-aos="fade-up">
                    <div className="pricing-content">
                        <div className="text-area">
                            <div className="content" data-aos="fade-up">
                                <SectionTitle title="Teeth Aligners FAQs" />
                                <div className="faq-grid" style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '15px', marginTop: '20px' }}>
                                    <p><strong>How long does treatment take?</strong> Ranges between several months and over a year depending on complexity.</p>
                                    <p><strong>Are they comfortable?</strong> Yes, though you may feel mild pressure during initial stages of each set.</p>
                                    <p><strong>Can adults use them?</strong> Absolutely, they are suitable for both teenagers and adults.</p>
                                    <p><strong>Do they affect speech?</strong> Initially, some notice slight changes, but this improves quickly within days.</p>
                                    <p><strong>How often should they be worn?</strong> Most of the day (20-22 hours) to ensure effective movement.</p>
                                    <p><strong>What happens after?</strong> Retainers are often recommended to maintain the new tooth alignment.</p>
                                </div>
                            </div>
                        </div>

                        <div className="price-cards">
                            <div className="price-card">
                                <div className="tag">Suitability</div>
                                <h3 className="price">Modern Choice</h3>
                                <p className="desc">Ideal for professional and social lifestyles</p>
                                <ul className="details">
                                    <li>● Discreet Appearance</li>
                                    <li>● Easy Maintenance</li>
                                    <li>● No Dietary Restrictions</li>
                                </ul>
                            </div>

                            <div className="price-card premium">
                                <div className="tag premium-tag">Monitoring</div>
                                <h3 className="price">Digital Tracking</h3>
                                <p className="desc">Precise oversight throughout treatment</p>
                                <ul className="details">
                                    <li>● Periodic Progress Checkups</li>
                                    <li>● Sequential Tray Adjustments</li>
                                    <li>● Guaranteed Precision Results</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>

                {/* WHY CHOOSE US TIMELINE */}
                <section className="why-kosmix-timeline">
                    <div className="content" data-aos="fade-up">
                        <SectionTitle title="Why Choose Kosmix for Your Aligner Journey?" />
                        <p1 className="text_first">
                            Our reputation in Bengaluru is built on a foundation of clinical expertise and patient-centered modern technology:
                        </p1>
                    </div>
                    <div className="timeline">
                        {reasons.map((reason, index) => (
                            <div className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`} key={index}>
                                <div className="timeline-icon">{reason.icon}</div>
                                <div className="timeline-content">
                                    <h3>{reason.title}</h3>
                                    <p style={{ display: window.innerWidth <= 768 ? 'none' : 'block' }}>
                                        {reason.description}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

                {/* CTA SECTION */}
                <section className="cta-section" data-aos='zoom-in'>
                    <div className="cta-content">
                        <h2>Achieve a Healthier Smile <span>Today!</span></h2>
                        <p>
                            Experience the modern way to straighten teeth. Schedule your personalized aligner consultation at Kosmix Dental Clinic in HSR Layout.
                        </p>
                        <div className="cta-buttons">
                            <Link to="/#appointment">
                                <button className="btn-primary">Book Aligner Consultation</button>
                            </Link>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

const SectionTitle = ({ title }) => (
    <h2 className="section-title">{title}</h2>
);

export default TeethAligners;